import { UseActiveOnScroll } from "../../hooks/useActiveOnScroll";
import styles from "./Skills.module.css";

const Skills = () => {
  const { observerRef: sectionRef, isVisible } = UseActiveOnScroll(0.2);

  return (
    <section
      className={`${styles.Skills} ${isVisible ? "active" : ""}`}
      name="Skills"
      ref={sectionRef}
    >
      <div className={styles.content}>
        <h1 className="section-header" style={{ "--x": "5%", "--y": "0rem" }}>
          Skills
        </h1>

        <div>
          <h3>Languages</h3>
          <li>C/C++</li>
          <li>Java (beginner)</li>
          <li>Python (beginner)</li>
        </div>
        
        <div>
          <h3>Frontend</h3>
          <li>HTML and CSS</li>
          <li>SASS</li>
          <li>React</li>
          <li>JavaScript</li>
          <li>TypeScript</li>
        </div>
        <div>
          <h3>Backend</h3>
          <li>NodeJS</li>
          <li>Express</li>
          <li>Flask</li>
          <li>MongoDB </li>
          <li>PostgreSql</li>
          <li>MySQL</li>
        </div>
        <div>
          <h3>Primary Tools</h3>
          <li>Visual Studio Code</li>
          <li>Canva</li>
          <li>Whimsical</li>
          <li>Figma</li>
          <li>Git and GitHub</li>
          <li>Bash</li>
          <li>Postman</li>
        </div>
      </div>
    </section>
  );
};

export { Skills };
